/*import React from 'react';
import './calisan.css'; 
import sampleImage from '../images/realcomment1.jpeg';
import sampleImage2 from '../images/realcomment5.jpeg';
import sampleImage3 from '../images/realcomment3.jpeg';
import sampleImage4 from '../images/realcomment4.jpeg';

const CalisanYorumlari = () => {

    return (
        <div>
            <h2>Çalışan Yorumları</h2>
        <div className="containner">
        <div className="testimonial-card">
            <div className="testimonial-image">
                <img src={sampleImage} alt="Profile" />
            </div>
            <div className="testimonial-content">
                <p>
                "Reeder bünyesinde Reeswap Değişim Birimi'nde Müşteri Temsilcisi olarak görev yapmaktan büyük bir mutluluk duyuyorum. Müşteri memnuniyetini en üst seviyede tutmak ve onlara en iyi hizmeti sunmak benim en büyük tutkum. Her gün, müşterilerimizin taleplerine en hızlı ve en etkili çözümleri sunmak için çalışıyorum. İşimi bu kadar sevmemin en büyük sebeplerinden biri, her gün yeni bir şeyler öğrenebilmek ve her müşterinin sorununu çözerek onların yüzündeki memnuniyeti görebilmek.
Reeswap'ta çalışmak bana sadece mesleki yetenekler kazandırmakla kalmıyor, aynı zamanda insani ilişkilerde de kendimi geliştirmemi sağlıyor. Ekibimle birlikte, her zorluğu aşmak ve Reeder müşterilerine en iyi deneyimi yaşatmak için her zaman elimizden gelenin en iyisini yapıyoruz. Bu yolculukta Reeder ailesinin bir parçası olmaktan gurur duyuyorum."</p>
                <h4>Aleyna Kırmızı - ReeSwap Müşteri Hizmetleri</h4>
            </div>
        </div>
        <div className="testimonial-card">
        <div className="testimonial-image">
                <img src={sampleImage2} alt="Profile" />
            </div>
            <div className="testimonial-content">
                <p>
                "Reeder ile stajyer olarak başladığım kariyer yolcuğuma, bugün insan kaynakları uzman yardımcısı olarak devam ediyorum. Reeder’ın genç ve dinamik çalışma ortamı, bana sürekli öğrenme ve kendimi geliştirme fırsatı sunuyor. Çalışan deneyimi, eğitim ve işe alım süreçlerinde aktif rol alarak hem profesyonel gelişimime hem de ekibimizin başarısına katkıda bulunmaya odaklanıyorum. Hayalini kurduğum birçok şeyin gerçeğinin mümkün olabileceğini görmek, kariyerime olan inancımı pekiştirmeye devam ediyor. İlk adımlarımı attığım bu şirkette, şimdi geleceğe daha emin ve kararlı adımlarla ilerlemeye devam ediyorum."
                </p>
                <h4>Gamze Yasemin Göçay - İnsan Kaynakları Uzman Yardımcısı</h4>
            </div>
        </div>
        <div className="testimonial-card">
        <div className="testimonial-image">
                <img src={sampleImage3} alt="Profile" />
            </div>
            <div className="testimonial-content">
                <p>
                "Reeder'da geçirdiğim 4 yıl, hem kişisel hem de profesyonel hayatımda bir dönüm noktası oldu. Burada sadece işimi öğrenmekle kalmadım, kendimi de keşfettim. Şirketim benim için aynı zamanda bir okul oldu ve bu sayede her zaman bir adım önde olmanın gururunu yaşıyorum. Reeder, büyüme ve gelişme için en ideal ortam."
                </p>
                <h4>Esra Karaca - AR-GE C Şefi</h4>
            </div>
        </div>
        <div className="testimonial-card">
        <div className="testimonial-image">
                <img src={sampleImage4} alt="Profile" />
            </div>
            <div className="testimonial-content">
                <p>
                "Her zaman hayat felsefem olan "Başarmanın sırrı başaracağına inanmaktır."sözü ile kariyerimin ilk adımlarını Reeder şirketin de attım. Çeşitli sosyal aktiviteler, geziler ve eğitimler ile hem kişisel gelişimimi hemde iş ile sosyal faaliyetlerin bir arada yürütüldüğünün en güzel kanıtını burda geçirdiğim 2 yıl süre zarfında çok iyi anladım. Reederlı olmak ayrıcalıktır. İyi ki Reederlıyım."
                </p>
                <h4>Melike Fırat - Üretim Personeli</h4>
            </div>
        </div>
        </div>
        </div>
    );
};

export default CalisanYorumlari;
*/

/*
import React, { useState } from 'react';
import './calisan.css';
import sampleImage from '../images/realcomment1.jpeg';
import sampleImage2 from '../images/realcomment5.jpeg';
import sampleImage3 from '../images/realcomment3.jpeg';
import sampleImage4 from '../images/realcomment4.jpeg';

const testimonials = [
    {
        image: sampleImage,
        text: `"Reeder bünyesinde Reeswap Değişim Birimi'nde Müşteri Temsilcisi olarak görev yapmaktan büyük bir mutluluk duyuyorum. Müşteri memnuniyetini en üst seviyede tutmak ve onlara en iyi hizmeti sunmak benim en büyük tutkum. Her gün, müşterilerimizin taleplerine en hızlı ve en etkili çözümleri sunmak için çalışıyorum. İşimi bu kadar sevmemin en büyük sebeplerinden biri, her gün yeni bir şeyler öğrenebilmek ve her müşterinin sorununu çözerek onların yüzündeki memnuniyeti görebilmek. Reeswap'ta çalışmak bana sadece mesleki yetenekler kazandırmakla kalmıyor, aynı zamanda insani ilişkilerde de kendimi geliştirmemi sağlıyor. Ekibimle birlikte, her zorluğu aşmak ve Reeder müşterilerine en iyi deneyimi yaşatmak için her zaman elimizden gelenin en iyisini yapıyoruz. Bu yolculukta Reeder ailesinin bir parçası olmaktan gurur duyuyorum."`,
        author: "Aleyna Kırmızı - ReeSwap Müşteri Hizmetleri",
    },
    {
        image: sampleImage2,
        text: `"Reeder ile stajyer olarak başladığım kariyer yolcuğuma, bugün insan kaynakları uzman yardımcısı olarak devam ediyorum. Reeder’ın genç ve dinamik çalışma ortamı, bana sürekli öğrenme ve kendimi geliştirme fırsatı sunuyor. Çalışan deneyimi, eğitim ve işe alım süreçlerinde aktif rol alarak hem profesyonel gelişimime hem de ekibimizin başarısına katkıda bulunmaya odaklanıyorum. Hayalini kurduğum birçok şeyin gerçeğinin mümkün olabileceğini görmek, kariyerime olan inancımı pekiştirmeye devam ediyor. İlk adımlarımı attığım bu şirkette, şimdi geleceğe daha emin ve kararlı adımlarla ilerlemeye devam ediyorum."`,
        author: "Gamze Yasemin Göçay - İnsan Kaynakları Uzman Yardımcısı",
    },
    {
        image: sampleImage3,
        text: `"Reeder'da geçirdiğim 4 yıl, hem kişisel hem de profesyonel hayatımda bir dönüm noktası oldu. Burada sadece işimi öğrenmekle kalmadım, kendimi de keşfettim. Şirketim benim için aynı zamanda bir okul oldu ve bu sayede her zaman bir adım önde olmanın gururunu yaşıyorum. Reeder, büyüme ve gelişme için en ideal ortam."`,
        author: "Esra Karaca - AR-GE C Şefi",
    },
    {
        image: sampleImage4,
        text: `"Her zaman hayat felsefem olan 'Başarmanın sırrı başaracağına inanmaktır.' sözü ile kariyerimin ilk adımlarını Reeder şirketinde attım. Çeşitli sosyal aktiviteler, geziler ve eğitimlerle hem kişisel gelişimimi hem de iş ile sosyal faaliyetlerin bir arada yürütüldüğünün en güzel kanıtını burada geçirdiğim 2 yıl süre zarfında çok iyi anladım. Reeder'lı olmak ayrıcalıktır. İyi ki Reeder'lıyım."`,
        author: "Melike Fırat - Üretim Personeli",
    },
];

const CalisanYorumlari = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const goToNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    };

    const goToPrevious = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
        );
    };

    return (
        <div className="calisan-container">
            <h2>Çalışan Yorumları</h2>
            <div className="slider">
                <button onClick={goToPrevious} className="arrow left-arrow">‹</button>
                <div className="testimonial-card">
                    <div className="testimonial-image">
                        <img src={testimonials[currentIndex].image} alt="Profile" />
                    </div>
                    <div className="testimonial-content">
                        <p>{testimonials[currentIndex].text}</p>
                        <h4>{testimonials[currentIndex].author}</h4>
                    </div>
                </div>
                <button onClick={goToNext} className="arrow right-arrow">›</button>
            </div>
            <div className="slider">
                <button onClick={goToPrevious} className="arrow left-arrow">‹</button>
                <div className="testimonial-card">
                    <div className="testimonial-image">
                        <img src={testimonials[currentIndex].image} alt="Profile" />
                    </div>
                    <div className="testimonial-content">
                        <p>{testimonials[currentIndex].text}</p>
                        <h4>{testimonials[currentIndex].author}</h4>
                    </div>
                </div>
                <button onClick={goToNext} className="arrow right-arrow">›</button>
            </div>
        </div>
    );
};

export default CalisanYorumlari;
*/


import React from 'react';
import './calisan.css';
import sampleImage from '../images/realcomment1.jpeg';
import sampleImage2 from '../images/realcomment5.jpeg';
import sampleImage3 from '../images/realcomment3.jpeg';
import sampleImage4 from '../images/realcomment4.jpeg';

// Birinci component: Kullanıcı Bilgisi
const UserInfo = ({ photo, name, company, position }) => {
  return (
    <div className="user-info">
      <img src={photo} alt={name} className="profile-pic" />
      <div className="user-details">
        <h3>
          <span className="employee-name">{name}</span> 
        </h3>
        <h4 className="employee-position">{position}</h4>
      </div>
    </div>
  );
};

// İkinci component: Yorum Metni
const UserComment = ({ comment }) => {
  return <p className="comment-text">{comment}</p>;
};

// Ana component: Yorum Kartı
const EmployeeComments = () => {
  const comments = [
    {
      name: 'Aleyna Kırmızı',
      position: 'ReeSwap Müşteri Hizmetleri',
      company: 'Hangar 53',
      comment:
        'Reeder bünyesinde Reeswap Değişim Birimi\'nde Müşteri Temsilcisi olarak görev yapmaktan büyük bir mutluluk duyuyorum. Müşteri memnuniyetini en üst seviyede tutmak ve onlara en iyi hizmeti sunmak benim en büyük tutkum. Her gün, müşterilerimizin taleplerine en hızlı ve en etkili çözümleri sunmak için çalışıyorum. İşimi bu kadar sevmemin en büyük sebeplerinden biri, her gün yeni bir şeyler öğrenebilmek ve her müşterinin sorununu çözerek onların yüzündeki memnuniyeti görebilmek. Reeswap\'ta çalışmak bana sadece mesleki yetenekler kazandırmakla kalmıyor, aynı zamanda insani ilişkilerde de kendimi geliştirmemi sağlıyor. Ekibimle birlikte, her zorluğu aşmak ve Reeder müşterilerine en iyi deneyimi yaşatmak için her zaman elimizden gelenin en iyisini yapıyoruz. Bu yolculukta Reeder ailesinin bir parçası olmaktan gurur duyuyorum.',
       photo: sampleImage,
    },
    {
      name: 'Gamze Yasemin Göçay',
      position: 'İnsan Kaynakları Uzman Yardımcısı',
      company: 'Hangar 53',
      comment:
        'Reeder ile stajyer olarak başladığım kariyer yolcuğuma, bugün insan kaynakları uzman yardımcısı olarak devam ediyorum. Reeder’ın genç ve dinamik çalışma ortamı, bana sürekli öğrenme ve kendimi geliştirme fırsatı sunuyor. Çalışan deneyimi, eğitim ve işe alım süreçlerinde aktif rol alarak hem profesyonel gelişimime hem de ekibimizin başarısına katkıda bulunmaya odaklanıyorum. Hayalini kurduğum birçok şeyin gerçeğinin mümkün olabileceğini görmek, kariyerime olan inancımı pekiştirmeye devam ediyor. İlk adımlarımı attığım bu şirkette, şimdi geleceğe daha emin ve kararlı adımlarla ilerlemeye devam ediyorum.',
      photo: sampleImage2,  
    },
    {
        name: 'Esra Karaca',
        position: 'AR-GE C Şefi',
        company: 'Hangar 53',
        comment:
          'Reeder\'da geçirdiğim 4 yıl, hem kişisel hem de profesyonel hayatımda bir dönüm noktası oldu. Burada sadece işimi öğrenmekle kalmadım, kendimi de keşfettim. Şirketim benim için aynı zamanda bir okul oldu ve bu sayede her zaman bir adım önde olmanın gururunu yaşıyorum. Reeder, büyüme ve gelişme için en ideal ortam.',
        photo: sampleImage3,
      },
      {
        name: 'Melike Fırat',
        position: 'Üretim Personeli',
        company: 'Hangar 53',
        comment:
          'Her zaman hayat felsefem olan \'Başarmanın sırrı başaracağına inanmaktır\' sözü ile kariyerimin ilk adımlarını Reeder şirketinde attım. Çeşitli sosyal aktiviteler, geziler ve eğitimlerle hem kişisel gelişimimi hem de iş ile sosyal faaliyetlerin bir arada yürütüldüğünün en güzel kanıtını burada geçirdiğim 2 yıl süre zarfında çok iyi anladım. Reeder\'lı olmak ayrıcalıktır. İyi ki Reeder\'lıyım.',
        photo: sampleImage4,
      },
  ];

  return (
    <div className="comments-container">
      {comments.map((item, index) => (
        <div key={index} className="comment-card">
          <UserInfo
            photo={item.photo}
            name={item.name}
            company={item.company}
            position={item.position}
          />
          <UserComment comment={item.comment} />
        </div>
      ))}
    </div>
  );
};

export default EmployeeComments;
/*
import React from 'react';
import './calisan.css';
import sampleImage from '../images/realcomment1.jpeg';
import sampleImage2 from '../images/realcomment5.jpeg';
import sampleImage3 from '../images/realcomment3.jpeg';
import sampleImage4 from '../images/realcomment4.jpeg';

// User Information Component
const UserInfo = ({ name, company, position }) => {
  return (
    <div className="user-info">
      <div className="user-details">
        <h3 className="employee-name">{name}</h3>
        <h4 className="employee-position">{position}</h4>
        <span className="employee-company">{company}</span>
      </div>
    </div>
  );
};

// Comment Text Component
const UserComment = ({ comment }) => {
  return <p className="comment-text">{comment}</p>;
};

// Main Employee Comments Component
const EmployeeComments = () => {
  const comments = [
    {
      name: 'Aleyna Kırmızı',
      position: 'ReeSwap Müşteri Hizmetleri',
      company: 'Hangar 53',
      comment:
        'Reeder bünyesinde Reeswap Değişim Birimi\'nde Müşteri Temsilcisi olarak görev yapmaktan büyük bir mutluluk duyuyorum. Müşteri memnuniyetini en üst seviyede tutmak ve onlara en iyi hizmeti sunmak benim en büyük tutkum.',
      photo: sampleImage,
    },
    {
      name: 'Gamze Yasemin Göçay',
      position: 'İnsan Kaynakları Uzman Yardımcısı',
      company: 'Hangar 53',
      comment:
        'Reeder ile stajyer olarak başladığım kariyer yolcuğuma, bugün insan kaynakları uzman yardımcısı olarak devam ediyorum. Reeder’ın genç ve dinamik çalışma ortamı, bana sürekli öğrenme ve kendimi geliştirme fırsatı sunuyor.',
      photo: sampleImage2,
    },
    {
      name: 'Esra Karaca',
      position: 'AR-GE C Şefi',
      company: 'Hangar 53',
      comment:
        'Reeder\'da geçirdiğim 4 yıl, hem kişisel hem de profesyonel hayatımda bir dönüm noktası oldu. Burada sadece işimi öğrenmekle kalmadım, kendimi de keşfettim. Reeder, büyüme ve gelişme için en ideal ortam.',
      photo: sampleImage3,
    },
    {
      name: 'Melike Fırat',
      position: 'Üretim Personeli',
      company: 'Hangar 53',
      comment:
        'Her zaman hayat felsefem olan \'Başarmanın sırrı başaracağına inanmaktır\' sözü ile kariyerimin ilk adımlarını Reeder şirketinde attım. Çeşitli sosyal aktiviteler, geziler ve eğitimlerle hem kişisel gelişimimi hem de iş ile sosyal faaliyetlerin bir arada yürütüldüğünün en güzel kanıtını burada geçirdiğim 2 yıl süre zarfında çok iyi anladım.',
      photo: sampleImage4,
    },
  ];

  return (
    <div className="comments-container">
      <div className="green-banner"></div>
      {comments.map((item, index) => (
        <div key={index} className={`comment-card ${index % 2 === 0 ? 'image-text' : 'text-image'}`}>
          {index % 2 === 0 ? (
            <>
              <img src={item.photo} alt={item.name} className="profile-pic" />
              <div className="comment-details">
                <h3>{item.name}</h3>
                <p>{item.comment}</p>
                <UserInfo name={item.name} company={item.company} position={item.position} />
              </div>
            </>
          ) : (
            <>
              <div className="comment-details">
                <h3>{item.name}</h3>
                <p>{item.comment}</p>
                <UserInfo name={item.name} company={item.company} position={item.position} />
              </div>
              <img src={item.photo} alt={item.name} className="profile-pic" />
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default EmployeeComments;

*/